<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="wifiData?.propertyName || 'Wi-Fi Router Status'"
      [canGoBack]="true"
      [customBack]="'revenue'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text [title]="wifiData?.propertyName || 'Wi-Fi Router Status'" />
        </div>
      </tidy-desktop-header>
    }

    @if (wifiData) {
      <tidy-card>
        <tidy-row [align]="'center'">
          <tidy-image
            [src]="statusIcon"
            style="height: 24px; margin-right: 8px;" />
          <tidy-text [header]="statusLabel" />
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row>
          <tidy-text [body]="'Router Model'" />
          <tidy-text [body]="wifiData.routerModel" />
        </tidy-row>
        <tidy-divider />
        <tidy-row>
          <tidy-text [body]="'Router IP'" />
          <tidy-text [body]="wifiData.routerIp" />
        </tidy-row>
        <tidy-divider />
        <tidy-row>
          <tidy-text [body]="'Last Ping'" />
          <tidy-text [body]="formattedLastPing" />
        </tidy-row>
        <tidy-divider />
        <tidy-row>
          <tidy-text [body]="'Latency'" />
          <tidy-text [body]="wifiData.latencyMs + (' ms' | translate)" />
        </tidy-row>
        <tidy-divider />
        <tidy-row>
          <tidy-text [body]="'Signal Strength'" />
          <tidy-text [body]="wifiData.signalStrength + '%'" />
        </tidy-row>
        <tidy-divider />
        <tidy-row>
          <tidy-text [body]="'Connected Devices'" />
          <tidy-text [body]="'' + wifiData.connectedDevices" />
        </tidy-row>
      </tidy-card>
    }

    @if (!wifiData) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No router data available.'" />
        </tidy-row>
      </tidy-alert>
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="windowService.isDesktopRes"
  [templateContent]="content" />
